import styled from "styled-components";

export const Root = styled.div`
  height: 119px;
  font-family: Roboto;
  font-size: 16px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
`;

export const Title = styled.div`
  padding: 10px 0px 7px 0px;
  font-weight: 500;
  text-align: left;
  color: #000;
`;